import React from "react"
import { Row, Col } from "reactstrap"
import ContainerMax from "components/shared/ContainerMax"
import FooterMenu from "./FooterMenu"

const FooterMenus = () => {
    return (
        <ContainerMax>
            <Row className="justify-content-center">
                <Col xs={6}>
                    <Row>
                        <FooterMenu menu={1} />
                        <FooterMenu menu={2} />
                        <FooterMenu menu={3} />
                    </Row>
                </Col>
                <Col xs={6}>
                    <Row>
                        <FooterMenu menu={4} />
                        <FooterMenu menu={5} />
                        <FooterMenu menu={6} displaySocial={true} />
                    </Row>
                </Col>
            </Row>
        </ContainerMax>
    )
}

export default FooterMenus